import Actions from './theme-actions';
import Api from './theme-api';
import Collection from './theme-collection';
import Model from './theme-model';
import reducer from './theme-reducer';
import Selectors from './theme-selectors';
import sagas from './theme-sagas';

export default {
  Actions,
  Api,
  Collection,
  Model,
  namespace: 'theme',
  reducer,
  sagas,
  Selectors,
};
